export default class PhysicalWorldFormDTO {
  constructor (data = {}) {
    if (!PhysicalWorldFormDTO.instance) {
      this.data = data
      this.error = false
      PhysicalWorldFormDTO.instance = this
    }

    return PhysicalWorldFormDTO.instance
  }

  addItem (data) {
    this.data = { ...data, ...this.data }
  }

  get () {
    return this.data
  }

  setError (error) {
    this.error = error
  }

  hasError () {
    return this.error
  }

  reset () {
    PhysicalWorldFormDTO.instance = null
  }
}
